export const futureRoutes = [
  { path: "/about", title: "About Us" },
  { path: "/videos", title: "Videos" },
  { path: "/testimonials", title: "Testimonials" },
  { path: "/faq", title: "FAQs" },
  { path: "/login", title: "Login / Sign Up" },
  { path: "/my-account", title: "My Account" },
  { path: "/orders", title: "My Orders" },
  { path: "/cart", title: "Cart" },
  { path: "/return-policy", title: "Return Policy" },
  { path: "/privacy-policy", title: "Privacy Policy" },
  { path: "/terms", title: "Terms & Conditions" }
];
